export default __webpack_public_path__ + "static/media/des-daoyu.daeb83f4.png";